export default "__VITE_ASSET__Xs7ynj6L__"